module.exports = __webpack_public_path__ + "static/assets/img/main-bg.c1027db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main-bg.jpg
// module id = Ys+L
// module chunks = 3